import {
  MessageResponseDto,
  PersonFingerprintEntity,
  CreatePersonFingerprintDto,
  EditPersonFingerprintDto,
  PersonFingerprintControllerCreate201Response,
  PersonFingerprintApiFp,
  DeletePersonFingerprintDto,
} from "@api/api";
import { apiConfig } from "@core/query/config.query";
import { QueryKey } from "@core/query/query-key.enum";

export type GetResponsePersonFingerprintModel =
  PersonFingerprintControllerCreate201Response;
export type GetPersonFingerprintModel = PersonFingerprintEntity;
export type MutateResponsePersonFingerprintModel = MessageResponseDto;
export type CreatePersonFingerprintModel = CreatePersonFingerprintDto;
export type UpdatePersonFingerprintModel = EditPersonFingerprintDto;
export type DeletePersonFingerprintModel = DeletePersonFingerprintDto;

export const apiPersonFingerprintFp = PersonFingerprintApiFp(apiConfig);
export const getPersonFingerprintController =
  apiPersonFingerprintFp.personFingerprintControllerGet;
export const createPersonFingerprintController =
  apiPersonFingerprintFp.personFingerprintControllerCreate;
export const updatePersonFingerprintController =
  apiPersonFingerprintFp.personFingerprintControllerEdit;
export const deletePersonFingerprintController =
  apiPersonFingerprintFp.personFingerprintControllerDelete;

export const QueryKeyPersonFingerprint = QueryKey.PersonFingerprint;
